var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"gnav"},[_c('ul',[_c('li',[_c('router-link',{staticClass:"fx_ctr",attrs:{"to":{name: 'SettingsTop'}},nativeOn:{"click":function($event){return _vm.toggleSpSlide(false)}}},[_c('span',{staticClass:"icon fx_ctr"},[_c('font-awesome-icon',{attrs:{"icon":"cog"}})],1),_c('span',{staticClass:"txt"},[_vm._v("Settings")])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }